export default __webpack_public_path__ + "static/media/nft8.87c8d6cf.png";